import React from 'react';
import _ from 'lodash';

interface ViewAttachmentLinter {
  totalAttachments: number;
  viewedAttachments: number;
  onViewAttachment(index: number): void;
  isAfterSubmitAttempt: boolean;
  onSubmitAttempt(): void;
}

const ViewAttachmentLinterContext = React.createContext<ViewAttachmentLinter>({
  isAfterSubmitAttempt: false,
  totalAttachments: 0,
  viewedAttachments: 0,
  onViewAttachment: _.noop,
  onSubmitAttempt: _.noop,
});

interface ViewAttachmentLinterProviderProps {
  totalAttachments: number;
  children?: React.ReactNode;
}

export const ViewAttachmentLinterProvider: React.FC<ViewAttachmentLinterProviderProps> = props => {
  const [isAfterSubmitAttempt, setIsAfterSubmitAttempt] = React.useState(false);
  const [viewedAttachments, onViewAttachment] = React.useReducer(
    (viewedAttachments: number[], attachment: number) => {
      if (viewedAttachments.includes(attachment)) {
        return viewedAttachments;
      }
      return _.sortBy(_.uniq([...viewedAttachments, attachment]), _.identity);
    },
    [],
  );
  const linterValue: ViewAttachmentLinter = React.useMemo(() => {
    return {
      totalAttachments: props.totalAttachments,
      viewedAttachments: viewedAttachments.length,
      onViewAttachment,
      isAfterSubmitAttempt,
      onSubmitAttempt: () => {
        setIsAfterSubmitAttempt(true);
      },
    };
  }, [
    props.totalAttachments,
    viewedAttachments.length,
    onViewAttachment,
    isAfterSubmitAttempt,
    setIsAfterSubmitAttempt,
  ]);
  return (
    <ViewAttachmentLinterContext.Provider value={linterValue}>
      {props.children}
    </ViewAttachmentLinterContext.Provider>
  );
};

export const useViewAttachmentLinter = (): ViewAttachmentLinter => {
  return React.useContext(ViewAttachmentLinterContext);
};
